/**
 * Created by Owner on 2016/10/20.
 */
export class MathUtil {
    static combination(c: number, b: number): any {
        b = parseInt(b.toString());
        c = parseInt(c.toString());
        if (b < 0 || c < 0) {
            return false
        }
        if (b == 0 || c == 0) {
            return 1
        }
        if (b > c) {
            return 0
        }
        if (b > c / 2) {
            b = c - b
        }
        var a = 0;
        for (let i = c; i >= (c - b + 1); i--) {
            a += Math.log(i)
        }
        for (let i = b; i >= 1; i--) {
            a -= Math.log(i)
        }
        a = Math.exp(a);
        return Math.round(a)
    }

    static moveString(a) {
        var h = "";
        var k = "01";
        var b = "";
        var f = "";
        var j = "";
        var g = false;
        var c = false;
        for (var e = 0; e < a.length; e++) {
            if (g == false) {
                h += a.substr(e, 1)
            }
            if (g == false && a.substr(e, 1) == "1") {
                c = true
            } else {
                if (g == false && c == true && a.substr(e, 1) == "0") {
                    g = true
                } else {
                    if (g == true) {
                        b += a.substr(e, 1)
                    }
                }
            }
        }
        h = h.substr(0, h.length - 2);
        for (var d = 0; d < h.length; d++) {
            if (h.substr(d, 1) == "1") {
                f += h.substr(d, 1)
            } else {
                if (h.substr(d, 1) == "0") {
                    j += h.substr(d, 1)
                }
            }
        }
        h = f + j;
        return h + k + b
    }

    static getCombination(o: any, c: any): any {
        var l = o.length;
        var r = new Array();
        if (c > l) {
            return r
        }
        if (c == 1) {
            return o
        }
        if (l == c) {
            r[0] = o.join(",");
            return r
        }
        var a = "";
        var b = "";
        var s = "";
        for (var g = 0; g < c; g++) {
            a += "1";
            b += "1"
        }
        for (var e = 0; e < l - c; e++) {
            a += "0"
        }
        for (var d = 0; d < c; d++) {
            s += o[d] + ","
        }
        r[0] = s.substr(0, s.length - 1);
        var h = 1;
        s = "";
        while (a.substr(a.length - c, c) != b) {
            a = MathUtil.moveString(a);
            for (var d = 0; d < l; d++) {
                if (a.substr(d, 1) == "1") {
                    s += o[d] + ","
                }
            }
            r[h] = s.substr(0, s.length - 1);
            s = "";
            h++
        }
        return r
    }
}



// WEBPACK FOOTER //
// ./src/util/mathUtil.ts